import { EAC_COUNTRIES } from "../../config/constants";

declare global {
  interface String {
    toTitleCase(): string;
    capitalize(): string;
    noUnderscore(): string;
    unitDisplay(qty: number, unit: string): string;
    isEmailValid(): boolean;
    toCountry(onlyFlag?: boolean): string;
  }
}

String.prototype.toTitleCase = function (): string {
  return this.replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

String.prototype.capitalize = function (): string {
  return this.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());
};

String.prototype.noUnderscore = function (): string {
  return this.replaceAll("_", " ");
};

String.prototype.unitDisplay = function (qty: number, unit: string): string {
  if (qty === 1) {
    const singularUnit = unit.endsWith("s") ? unit.slice(0, -1) : unit;
    return singularUnit;
  }

  const pluralUnit = unit.endsWith("s") ? unit : `${unit}s`;
  return pluralUnit;
};

String.prototype.isEmailValid = function (): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.toString());
};

String.prototype.toCountry = function (onlyFlag?: boolean): string {
  const rwanda = EAC_COUNTRIES.find((country) => country.key === "RW");

  try {
    const countryCode = this.toString();

    const country =
      EAC_COUNTRIES.find((country) => country.key === countryCode) ||
      EAC_COUNTRIES.find((country) => country.key === "RW");

    return onlyFlag
      ? country?.flag || ""
      : `${country?.flag || ""} ${country?.name || "Rwanda"} `;
  } catch (error) {
    return onlyFlag
      ? rwanda?.flag || ""
      : `${rwanda?.flag || ""} ${rwanda?.name || "Rwanda"} `;
  }
};

export {};
